import { __rest } from 'tslib';
import React, { useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { s as styled } from './styled-112a8bd0.js';

const Container = styled.div `
  [data-popper-reference-hidden] {
    visibility: hidden;
    pointer-events: none;
  }
`;
const Popper = (_a) => {
    var { children, referenceElement, className, placement } = _a, _b = _a.popperConfig, _c = _b === void 0 ? {} : _b, { modifiers = [] } = _c, rest = __rest(_c, ["modifiers"]);
    const [popperElement, setPopperElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const { styles, attributes, update } = usePopper(referenceElement, popperElement, Object.assign({ placement, modifiers: [
            {
                name: 'arrow',
                options: { element: arrowElement },
            },
            {
                name: 'flip',
                enabled: true,
            },
            { name: 'hide' },
            ...modifiers,
        ] }, rest));
    useEffect(() => {
        if (update) {
            update();
        }
    }, [className]);
    return (React.createElement(Container, Object.assign({ ref: setPopperElement, style: styles.popper }, attributes.popper, { className: className }),
        children,
        React.createElement("div", { ref: setArrowElement, style: styles.arrow })));
};

export { Popper as P };
